export default __webpack_public_path__ + "static/media/xls.df3e8d27.png";